import { createFileRoute } from "@tanstack/react-router";
import { GoogleReviewPage, buildGoogleReviewHead } from "@/components/shop/GoogleReviewPage";
import { googleReviewDictEl } from "@/lib/shop/products/google-review";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/el/shop_/google-review")({
  head: () => ({
    ...buildGoogleReviewHead(googleReviewDictEl),
    links: alternateLinkList("/shop/google-review", "el"),
  }),
  component: () => <GoogleReviewPage dict={googleReviewDictEl} />,
});
